import { IconBase, IconBaseProps } from 'react-icons';

export function LogoIcon(props: IconBaseProps) {
    return (
        <IconBase id="logo-icon" data-testid="LogoIcon" {...props} viewBox="0 0 20 24">
            <path
                fill="currentColor"
                d="M0 3.194A3.192 3.192 0 0 1 3.19 0h13.62a3.192 3.192 0 0 1 2.948 4.416 3.192 3.192 0 0 1-2.948 1.973H3.19A3.192 3.192 0 0 1 0 3.194Zm0 17.268v-6.735a3.192 3.192 0 0 1 3.19-3.194c1.761 0 3.19 1.43 3.19 3.194v6.735a3.192 3.192 0 0 1-4.411 2.95A3.193 3.193 0 0 1 0 20.462Z"
            />
            <path
                fill="currentColor"
                d="M10.517 13.986a3.448 3.448 0 0 1 3.449-3.453h1.637c.762 0 1.38.618 1.38 1.381v1.64a3.45 3.45 0 0 1-3.449 3.454h-1.637a1.38 1.38 0 0 1-1.38-1.381v-1.641Z"
            />
        </IconBase>
    );
}
